import { MainPageLayout } from 'shared/components/MainPageLayout';
import { PresentationBlockContainer } from 'shared/containers/PresentationBlockContainer';
import { MainContentContainer } from '../../MainContentContainer';

export const MainPage = () => {
  return <MainPageLayout presentationBlock={<PresentationBlockContainer />} mainBlock={<MainContentContainer />} />;
};
